export default [
  {
    path: '/license-expire-date',
    name: 'ExpireDateContent',
    component: () => import('@/pages/license/ExpireDateContent.vue'),
    meta: {},
  },
];
